// One service on a new booking, made from a service as the staff member's
// service list returns it (hairdresserService.getServicesGroupedV2). Used by
// the new-booking panel's picker, and by Bailey when it fills the panel in.
export function serviceLine(service, staffId) {
  const colour = service.diaryColour || service.service?.diaryColour || null;
  // The getHairdresserService endpoint sometimes nests per-staff overrides
  // under either `staff[]`, `hairdressers[]`, or flattens them at the top
  // level. Resolve from any of those paths so setupTime/cleanupTime reach
  // the create payload regardless of the backend's chosen shape.
  const staffMatch = (Array.isArray(service.staff) && service.staff.find(x => x.hairdresserId === staffId || x._id === staffId))
    || (Array.isArray(service.hairdressers) && service.hairdressers.find(x => x.hairdresserId === staffId || x._id === staffId))
    || null;
  const resolvedSetup = service.setupTime ?? staffMatch?.setupTime ?? 0;
  const resolvedCleanup = service.cleanupTime ?? staffMatch?.cleanupTime ?? 0;
  const resolvedProcessing = service.processingTime ?? staffMatch?.processingTime ?? 0;
  const resolvedFinishing = service.finishingTime ?? staffMatch?.finishingTime ?? 0;
  return {
    service: {
      serviceId: service._id || service.serviceId,
      _id: service._id || service.serviceId,
      serviceName: service.serviceName,
      servicePrice: service.servicePrice,
      diaryColour: colour,
    },
    serviceId: service._id || service.serviceId,
    serviceName: service.serviceName,
    servicePrice: service.servicePrice,
    serviceTime: service.serviceTime || 30,
    processingTime: resolvedProcessing,
    finishingTime: resolvedFinishing,
    // Inherit setup/cleanup defaults from the service definition. These can
    // be overridden per-booking via BookingDetailPanel once the booking is
    // saved; the defaults flow into the panel's create payload.
    setupTime: resolvedSetup,
    cleanupTime: resolvedCleanup,
    diaryColour: colour,
    hairdresserId: staffId,
  };
}
